const React = require('react')
const { lazy } = require('react')
const { hot } = require('react-hot-loader')
const { Switch, Route } = require('react-router-dom')
const { routes } = require('@routes')
const { Layout } = require('@layouts')

require('@styles/configs/agridential.style.css')
require('@styles/configs/haugiang.style.css')
require('@styles/configs/mbc.style.css')
require('@styles/configs/vibi.style.css')
require('@styles/configs/vibi2.style.css')
require('@styles/react/table.style.css')

const createLazyComponent = route =>
    lazy(() =>
        Promise.resolve().then(() => {
            const component = require(`@pages/${route.component}.page${
                route.subComponent ? `/${route.subComponent}.page` : ''
            }`)

            return { default: component }
        })
    )

const renderRoute = (route, props, i) => {
    const LazyComponent = createLazyComponent(route)
    return (
        <Route key={i} path={route.path} exact={true}>
            <Layout {...route} {...props}>
                <LazyComponent {...route} {...props} />
            </Layout>
        </Route>
    )
}

const App = props => <Switch>{routes.map((route, i) => renderRoute(route, props, i))}</Switch>

module.exports = hot(module)(App)
